<template>
  <div class>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="font-weight: 600; color: #000">电桩信息</span>
        <!-- <div class="btns" style="margin-top: 30px;display: flex;align-items: center;justify-content: center;">
          <el-button @click="cancel">返回</el-button>
        </div> -->
        <el-button type="primary" plain @click="cancel" style="float: right; padding: 3px 0">返回</el-button>
      </div>
      <div class>
        <SForm
          ref="formref"
          :fields="formfields"
          :dataForm="rowdata"
          labelWidth="200px"
          :isShowBtn="false"
          :inline="false"
        >
        </SForm>
      </div>
    </el-card>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="font-weight: 600; color: #000">充电枪信息</span>
      </div>
      <div class>
        <SForm
          ref="formref2"
          :fields="formfields2"
          :dataForm="rowdata"
          labelWidth="150px"
          :isShowBtn="false"
          :inline="false"
        >
        </SForm>
      </div>
    </el-card>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="font-weight: 600; color: #000">充电枪修改信息</span>
      </div>
      <div>
        <SForm
          ref="formref3"
          :fields="formfields3"
          :dataForm="rowdata"
          labelWidth="150px"
          :isShowBtn="false"
          :inline="false"
        >
        </SForm>
      </div>
    </el-card>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="font-weight: 600; color: #000">运营信息</span>
      </div>
      <STable
        ref="tablerefs"
        :url="urls"
        :selection="false"
        :columns="columnss"
        :isNum="true"
      ></STable>
    </el-card>
  </div>
</template>
  <script>
import { HOST, EV_HOST } from "@/utils/host";
import times from "./data.json";
export default {
  name: "dianzhuangxiangqing",
  components: {},
  data() {
    return {
      urls: "/station/equipment/page",
      columnss: [
        {
          label: "时段",
          prop: "connectorName",
        },
        {
          label: "电费（元/度）",
          prop: "brandName",
        },
        {
          label: "服务费（元/度）",
          prop: "brandModel",
        }
      ],
      rowdata: {},
      formfields: [
        {
          label: "电桩编码",
          type: "div",
          prop: "stationName",
        },
        {
          label: "电桩类型",
          type: "div",
          prop: "capacitanceSize",
        },
        {
          label: "品牌型号",
          type: "div",
          prop: "",
        },
        {
          label: "电桩国际",
          type: "div",
          prop: "address",
        },
        {
          label: "电桩功率",
          type: "div",
          prop: "lnglat",
        },
        {
          label: "辅助电源支持",
          type: "div",
          prop: "operatorName",
        },
        {
          label: "输入电压",
          type: "div",
          prop: "stationLocation",
        },
        {
          label: "最大电压",
          type: "div",
          prop: "brake",
        },
        {
          label: "最小电压",
          type: "div",
          prop: "parkInstruction",
        },
        {
          label: "最大电流",
          type: "div",
          prop: "busineHoursInstruction",
        },
        {
          label: "最小电流",
          type: "div",
          prop: "siteProperties",
        },
        {
          label: "恒功率区间",
          type: "div",
          prop: "stationTypeValue",
        },
        {
          label: "并充支持",
          type: "div",
          prop: "constructionValue",
        }
      ],
      formfields2:[
        {
          label:"充电枪编码",
          type:"div",
          prop:""
        },
        {
          label:"充电枪名称",
          type:"div",
          prop:""
        },
        {
          label:"启停状态",
          type:"div",
          prop:""
        },
        {
          label:"工作状态",
          type:"div",
          prop:""
        },
        {
          label:"归属电站",
          type:"div",
          prop:""
        },
        {
          label:"电站属性",
          type:"div",
          prop:""
        },
        {
          label:"投运时间",
          type:"div",
          prop:""
        },
        {
          label:"协议版本",
          type:"div",
          prop:""
        },
        {
          label:"通讯运营商",
          type:"div",
          prop:""
        },
        {
          label:"SIM卡号",
          type:"div",
          prop:""
        },
        {
          label:"设备生产日期",
          type:"div",
          prop:""
        },
        {
          label:"车位号",
          type:"div",
          prop:""
        },
        {
          label:"有无地锁",
          type:"div",
          prop:""
        },
        {
          label: "充电枪二维码",
          imageSrc: "",
          type: "image",
        },
      ],
      formfields3:[
        {
          label:"创建人",
          type:"div",
          prop:""
        },
        {
          label:"创建时间",
          type:"div",
          prop:""
        },
        {
          label:"修改人",
          type:"div",
          prop:""
        },
        {
          label:"修改时间",
          type:"div",
          prop:""
        }
      ],
      id: "",
    };
  },
  computed: {},
  methods: {
    cancel() {
      this.$router.go(-1);
    },
  },
  mounted() {
    if (this.id) {
      let data = {
        id: this.id,
      };
      this.$store.dispatch("form/handle", {
        url: "/station/getEditData",
        data: data,
        method: "get",
        callback: (resp) => {
          console.log("resp", resp);
          let lnglat = "E" + String(resp.stationLng) + "，" + "N" + String(resp.stationLat);
          this.rowdata = resp;
          this.rowdata.lnglat = lnglat;
          if (resp.brake === true) {
            this.rowdata.brake = "有道闸";
          } else if (resp.brake === false) {
            this.rowdata.brake = "无道闸";
          }

          if (resp.capacitanceSize) {
            this.rowdata.capacitanceSize = resp.capacitanceSize + "KV·A";
          }



          if (resp.appCanSee === true) {
            this.rowdata.appCanSee = "可见";
          } else if (resp.appCanSee === false) {
            this.rowdata.appCanSee = "不可见";
          }

          if (resp.disable === true) {
            this.rowdata.disable = "启用";
          } else if (resp.disable === false) {
            this.rowdata.disable = "停用";
          }
          const that = this;
          if (resp.ranges.length > 0) {
            resp.ranges.forEach((item, index) => {
              let obj = {
                loginName: "",
                userName: "",
                roleNames: "",
              };
              let start = "";
              let end = "";
              times.timeList.forEach((el, em) => {
                if (item.priceStartPeriod === el.value) {
                  start = el.label;
                }
                if (item.priceEndPeriod === el.value) {
                  end = el.label;
                }
              });
              if (start === "" && end === "") {
                obj.loginName = "其他时段";
              } else {
                obj.loginName = start + "至" + end;
              }
              obj.userName = this.getFloat(item.cpoElecMoney);
              obj.roleNames = this.getFloat(item.cpoServiceMoney);
            });
          }
          this.showTable = true;
        },
      });
    }
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data;
  }, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

  <style lang="less" src="" scoped>
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/plantManagement/InterConPileDetail.vue